import ExternalLink from '../icons/ExternalLink.svg';
import React from 'react';
import { FC } from 'react';

const SupportArticlesButton: FC = () => {
  return (
    <div className='flex flex-col sm:flex-row sm:items-center sm:justify-center'>
      <p className='body-paragraph'>Have more questions?&nbsp;</p>
      <a href='https://support.online.church/' target='_blank' rel='noreferrer'>
        <div className='flex text-lg font-semibold text-primary hover:text-primary-hover'>
          Browse support articles
          <div className='mt-1 ml-0.5'>
            <ExternalLink className='fill-current' />
          </div>
        </div>
      </a>
    </div>
  );
};

export default SupportArticlesButton;
